// extracted by mini-css-extract-plugin
export default {"footer1":"footer_footer1__AOkEr"};